import { useRef, memo } from 'react'
import { useWavesurfer } from '@wavesurfer/react'
import { Pause, PlayIcon, VolumeActive, VolumeMute } from '../icons'
import styles from './styles.module.scss'

const formatTime = (seconds) => [seconds / 60, seconds % 60].map((v) => `${Math.floor(v)}`).join(':')

function AudioPlayer({ source }) {
  const containerRef = useRef(null)

  const { wavesurfer, isPlaying, currentTime } = useWavesurfer({
    container: containerRef,
    url: source,
    waveColor: '#000000',
    height: 25,
    barWidth: 2,
    barGap: 4,
    barRadius: 2,
    progressColor: '#5865F2',
    cursorWidth: 0,
  })

  const handleToggleMute = () => {
    const isMuted = wavesurfer.getMuted()
    wavesurfer.setMuted(!isMuted)
  }

  const onPlayPause = () => {
    wavesurfer && wavesurfer.playPause()
  }

  const renderInnerIcon = isPlaying ? <Pause pureSvg={true} /> : <PlayIcon pureSvg={true} />

  return (
    <div className={styles.audio_player}>
      <div className={styles.audio_player__time_volume}>
        <button onClick={handleToggleMute} className={styles.volume_control}>
          {wavesurfer && wavesurfer.getMuted() ? <VolumeMute /> : <VolumeActive />}
        </button>

        <span className={styles.audio_player__time}>{formatTime(currentTime)}</span>
      </div>

      <div className={styles.visual_graph} ref={containerRef} />
      <button className={styles.audio_control_btn} onClick={onPlayPause}>
        {renderInnerIcon}
      </button>
    </div>
  )
}

export default memo(AudioPlayer)
